import { decodeHtmlEntities } from "../../../../../common/helpers/decodeHtmlEntities";
import type { RawWPRestAttribute } from "../../../../../types";
import type {
  TransformedWPAttribute,
  TransformedWPAttributeTerm,
} from "../../types/productTaxonomyApiTypes";

// Define the dependency type
interface LanguageInfo {
  shouldTranslate: boolean;
}

/**
 * Transforms raw attribute data from our custom endpoint.
 * @param attribute - Raw attribute data.
 * @param languageInfo - Object containing translation status.
 * @returns Transformed attribute data.
 */
export const transformAttribute = (
  attribute: RawWPRestAttribute,
  languageInfo: LanguageInfo
): TransformedWPAttribute => {
  const { shouldTranslate } = languageInfo;

  // Determine Attribute Name
  let attrName = attribute.name;
  if (shouldTranslate && attribute.translated_name) {
    attrName = attribute.translated_name;
  }
  attrName = decodeHtmlEntities(attrName);

  const termsById = attribute.terms.reduce(
    (acc, term) => {
      // Determine Term Name
      let termName = term.name;
      if (shouldTranslate && term.translated_name) {
        termName = term.translated_name;
      }
      termName = decodeHtmlEntities(termName);

      const transformedTerm: TransformedWPAttributeTerm = {
        id: term.id,
        name: termName,
        slug: term.slug,
        count: term.count,
        type: term.type,
        buttonColor: term["button-color"],
        buttonImage: term["button-image"],
      };
      acc[term.id] = transformedTerm;
      return acc;
    },
    {} as TransformedWPAttribute["terms"]
  );

  return {
    id: attribute.id,
    name: attrName,
    slug: attribute.slug,
    taxonomy: attribute.taxonomy,
    displayType: attribute.display_type,
    terms: termsById,
  };
};
